import { buildMessageTimestampStr } from '@/utils/dateUtils';
import { Message } from '@/models/Message';
import { mkTimestampTrackAttrs } from '@/analytics/props/msg';

import { Typography } from '@mui/material';

export interface MessageTimestampProps {
  message: Message;
}

export const MessageTimestamp = ({ message }: MessageTimestampProps) => {
  return (
    <Typography
      variant="body2"
      sx={{ opacity: 0.8 }}
      {...mkTimestampTrackAttrs({ messageId: message.id })}
    >
      {buildMessageTimestampStr(message.timestamp)}
    </Typography>
  );
};
